export function isSelfOnlyCapsule(capsule, userId = "") {
  const isCurrentUserSender =
    Boolean(userId) && String(capsule?.senderId || "") === String(userId);
  if (!isCurrentUserSender) return false;

  const recipientUserIds = Array.isArray(capsule?.recipientUserIds)
    ? capsule.recipientUserIds.filter(Boolean)
    : [];
  const claimedBy = Array.isArray(capsule?.claimedBy)
    ? capsule.claimedBy.filter(Boolean)
    : [];
  const recipientPhones = Array.isArray(capsule?.recipientPhoneNumbers)
    ? capsule.recipientPhoneNumbers.filter(Boolean)
    : [];
  const recipientOnlySelf =
    recipientUserIds.length > 0 &&
    userId &&
    recipientUserIds.every((id) => id === userId);
  const claimOnlySelf =
    claimedBy.length > 0 &&
    userId &&
    claimedBy.every((id) => id === userId);

  return (
    capsule?.isSelfCapsule === true ||
    capsule?.audience === "self" ||
    (userId && recipientUserIds.length === 1 && recipientUserIds[0] === userId) ||
    recipientOnlySelf ||
    (capsule?.deliveryMode === "share_claim" &&
      recipientPhones.length === 0 &&
      claimOnlySelf)
  );
}

export function getCapsuleDisplayKind(capsule, userId = "") {
  if (capsule?.isDraft) return "draft";

  const type = String(capsule?.capsuleType || "").toLowerCase();
  if (type === "memberexclusive") return "exclusive";
  if (type === "sponsored") return "featured";
  if (type !== "private") return "public";

  if (isSelfOnlyCapsule(capsule, userId)) return "memory";
  return capsule?.senderId === userId ? "sent" : "received";
}

export function getCapsuleDisplayLabel(capsule, userId = "") {
  const kind = getCapsuleDisplayKind(capsule, userId);
  if (kind === "draft") return "Draft";
  if (kind === "featured") return "Featured";
  if (kind === "exclusive") return "Member Exclusive";
  if (kind === "memory") return "Memory";
  if (kind === "sent") return "Buried";
  if (kind === "received") return "Received";
  return "Public";
}
